import { render, staticRenderFns } from "./DashboardSettings.vue?vue&type=template&id=32b3b443&scoped=true"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"
import style0 from "./DashboardSettings.vue?vue&type=style&index=0&id=32b3b443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b3b443",
  null
  
)

export default component.exports